import { render } from "./albumfotos.vue?vue&type=template&id=2db3156c&scoped=true"
import script from "./albumfotos.vue?vue&type=script&lang=js"
export * from "./albumfotos.vue?vue&type=script&lang=js"

import "./albumfotos.vue?vue&type=style&index=0&id=2db3156c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db3156c"]])

export default __exports__